import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { HTTP_VERBS } from 'utils/constants';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, API_ENDPOINTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';

const useCreateReservation = reservation => {
  const path = API_ENDPOINTS.RESERVATIONS;

  const { t } = useTranslation(LOCALIZATION_PAGES.RESERVATION);
  const { showNotification } = useRoot();
  const [{ result, loading, error }, createReservation] = useApi(path, {
    initialFetch: false,
    verb: HTTP_VERBS.POST,
    data: reservation,
  });

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('reservation_create_fail'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (result) {
      showNotification({
        message: t('reservation_create_success'),
      });
    }
  }, [result, showNotification, t]);

  return [{ result, loading, error }, createReservation];
};

export default useCreateReservation;
